import { initialState, QuotesState, quotesAdapter } from './quotes.interfaces';
import * as fromQuotes from './quotes.actions';

export function reducer(state = initialState, action: fromQuotes.QuotesAction): QuotesState {
  switch (action.type) {
    case fromQuotes.GET_QUOTES_FROM_SERVER_SUCCESS: {
      return {
        ...quotesAdapter.addMany(action.payload.quotes, state)
      };
    }
    case fromQuotes.GET_QUOTE_FROM_SERVER_SUCCESS: {
      return {
        ...quotesAdapter.addOne(action.payload.quote, state)
      };
    }

    default: {
      return state;
    }
  }
}
